<ng-container *ngIf="cargando">
  <div fxLayout="column" class="p-20" fxLayoutAlign="space-between center" >
    <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
    <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
  </div>
</ng-container>

<ng-container *ngIf="!cargando">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign="start center">
      <button mat-raised-button color="accent" class="mr-10" (click)="configuracionTemplate(configItbm)">
        {{'CERTIFICARV3.TAB_PREGUNTAS.BTN_CONFIG_PLA' | translate}}
        <mat-icon class="ml-20">settings</mat-icon>
      </button>
    </div>
  </div>
  <mat-divider class="mt-20"></mat-divider>
  <form [formGroup]="formGroupForAll">
    <mat-table [dataSource]="dataSource" [@animate]="{value:'*',params:{delay:'250ms',y:'25px'}}" class="mb-100">

      <ng-container matColumnDef="practice" >
        <mat-header-cell *matHeaderCellDef class="pracDes">
          <p> {{'CERTIFICAR.FORALL.TABLA.ENCABEZADOS.PRACT' | translate}}</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let element;let idxPract = index;" fxLayout="column" fxLayoutAlign="stretch">
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>{{'CERTIFICAR.FORALL.TABLA.INPUTS.PRACT' | translate}}</mat-label>
              <textarea matInput required [formControlName]="'practica' + idxPract" (keyup)="actualizaStatement($event,idxPract)" (blur)="guardaDatosPractica($event,idxPract,1)"></textarea>
            <mat-error *ngIf="instituto!='TK'">{{'CERTIFICAR.FORALL.MSJ_PRACTICEREQUIRED' | translate}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef class="pracDes">
          <p>{{'CERTIFICAR.FORALL.TABLA.ENCABEZADOS.DESCR' | translate}}</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let element;let idxDescr = index;">
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>{{'CERTIFICAR.FORALL.TABLA.INPUTS.DESCR' | translate}}</mat-label>
            <textarea matInput required [formControlName]="'descrip' + idxDescr" (keyup)="actualizaStatementDescripcion($event,idxDescr)"  (blur)="guardaDatosPractica($event,idxDescr,2)"></textarea>
            <mat-error *ngIf="instituto!='TK'">{{'CERTIFICAR.FORALL.MSJ_DESCRIPTIONREQUIRED' | translate}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="statement1">
        <mat-header-cell *matHeaderCellDef class="statems">
          <p>  {{'CERTIFICAR.FORALL.TABLA.ENCABEZADOS.STT1' | translate}}</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let element;let idxPract = index;" style="text-align: center;">
          <div fxLayout="column" fxLayoutAlign="start stretch">
            <p style="padding: 10px;" >{{element.statement1Part1}} <code>{{ element.practice }}</code> {{ element.statement1Part2 }}</p>
            <ng-container *ngIf="element.objetoStatement1 && (configTemplate.audios == true && configTemplate.audiosGlobal == true)">
              <ng-container *ngFor="let idioma of element.objetoStatement1.questionLanguage">
                <ng-container *ngIf="idioma.lang == idiomaNative">
                  <div fxLayout="row" fxLayoutAlign="end center" *ngIf="idioma.audio == false">
                    <em>{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.SIN_AUDIO_FORALL' | translate}}</em>
                    <button mat-mini-fab color="primary" class="ml-20" matTooltip="Reemplazar audio" (click)="DEMO_agregarAudioPregunta(idxPract, 1, 'ADD')">
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
                  <ng-container *ngIf="idioma.audio == true">
                    <p><em>{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.CON_AUDIO' | translate}}</em></p>
                    <div fxLayout="row">
                      <button mat-mini-fab matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.PLAY' | translate}}" (click)="DEMO_reproducirAudioPregunta(idxPract, 1)" *ngIf="idioma.audioUrl.length == 0">
                        <mat-icon>play_arrow</mat-icon>
                      </button>
                      <audio controls *ngIf="idioma.audioUrl.length > 0">
                        <source [src]="sanitizer.bypassSecurityTrustResourceUrl(idioma.audioUrl)" type="audio/mpeg">
                        Your browser does not support the audio element.
                      </audio>
                      <button mat-mini-fab color="accent" class="ml-20" matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.CHANGE' | translate}}" (click)="DEMO_agregarAudioPregunta(idxPract, 1, 'CHANGE')">
                        <mat-icon>import_export</mat-icon>
                      </button>
                      <button mat-mini-fab color="primary" class="ml-20" matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.DELETE' | translate}}" (click)="DEMO_borrarAudioPregunta(idxPract, 1)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="statement2">
        <mat-header-cell *matHeaderCellDef class="statems">
          <p>  {{'CERTIFICAR.FORALL.TABLA.ENCABEZADOS.STT2' | translate}}</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let element;let idxPract = index;" style="text-align: center;">
          <div fxLayout="column" fxLayoutAlign="start stretch">
            <ng-container *ngIf="instituto=='TK'">
              <p style="padding: 10px;">{{element.statement2Part1}} <code>{{ element.practice }}</code> {{ element.statement2Part2 }} ?</p>
            </ng-container>
            <ng-container *ngIf="instituto!='TK'">
              <p style="padding: 10px;">{{element.statement2Part1}} <code>{{ element.practice }}</code> {{ element.statement2Part2 }} <code>{{ nombreEmpresa }}</code>?</p>
            </ng-container>
            <ng-container *ngIf="element.objetoStatement2 && (configTemplate.audios == true && configTemplate.audiosGlobal == true)">
              <ng-container *ngFor="let idioma of element.objetoStatement2.questionLanguage">
                <ng-container *ngIf="idioma.lang == idiomaNative">
                  <div fxLayout="row" fxLayoutAlign="end center" *ngIf="idioma.audio == false">
                    <em>{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.SIN_AUDIO' | translate}}</em>
                    <button mat-mini-fab color="primary" class="ml-20" matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.ADD_AUDIO' | translate}}" (click)="DEMO_agregarAudioPregunta(idxPract, 2, 'ADD')">
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
                  <ng-container *ngIf="idioma.audio == true">
                    <p><em>{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.CON_AUDIO' | translate}}</em></p>
                    <div fxLayout="row">
                      <button mat-mini-fab matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.PLAY' | translate}}" (click)="DEMO_reproducirAudioPregunta(idxPract, 2)" *ngIf="idioma.audioUrl.length == 0">
                        <mat-icon>play_arrow</mat-icon>
                      </button>
                      <audio controls *ngIf="idioma.audioUrl.length > 0">
                        <source [src]="sanitizer.bypassSecurityTrustResourceUrl(idioma.audioUrl)" type="audio/mpeg">
                        Your browser does not support the audio element.
                      </audio>
                      <button mat-mini-fab color="accent" class="ml-20" matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.CHANGE' | translate}}" (click)="DEMO_agregarAudioPregunta(idxPract, 2, 'CHANGE')">
                        <mat-icon>import_export</mat-icon>
                      </button>
                      <button mat-mini-fab color="primary" class="ml-20" matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.DELETE' | translate}}" (click)="DEMO_borrarAudioPregunta(idxPract, 2)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </form>
</ng-container>
